<template lang="pug">
  component(:is="component" :change="change" :class="[ change.type ]")
</template>

<script>
import TaskChangeStatus from '@/components/task/change/TaskChangeStatus.vue';
import TaskChangePriority from '@/components/task/change/TaskChangePriority.vue';
import TaskChangeAuthor from '@/components/task/change/TaskChangeAuthor.vue';
import TaskChangeManager from '@/components/task/change/TaskChangeManager.vue';
import TaskChangeMembers from '@/components/task/change/TaskChangeMembers.vue';
import TaskChangeClosure from '@/components/task/change/TaskChangeClosure.vue';
import TaskChangeChecklist from '@/components/task/change/TaskChangeChecklist.vue';
import TaskChangeDates from '@/components/task/change/TaskChangeDates.vue';
import TaskChangeDescription from '@/components/task/change/TaskChangeDescription.vue';
import TaskChangeCommentDeleted from '@/components/task/change/TaskChangeCommentDeleted.vue';

export default {
  name: 'TaskChangeComponentSelector',
  components: {
    TaskChangeStatus,
    TaskChangePriority,
    TaskChangeAuthor,
    TaskChangeManager,
    TaskChangeMembers,
    TaskChangeClosure,
    TaskChangeDescription,
    TaskChangeDates,
    TaskChangeChecklist,
    TaskChangeCommentDeleted,
  },
  props: {
    change: Object,
  },
  computed: {
    component() {
      const components = {
        status: TaskChangeStatus,
        priority: TaskChangePriority,
        author: TaskChangeAuthor,
        manager: TaskChangeManager,
        members: TaskChangeMembers,
        closure: TaskChangeClosure,
        description: TaskChangeDescription,
        dates: TaskChangeDates,
        checklist: TaskChangeChecklist,
        'comment-delete': TaskChangeCommentDeleted,
      };

      return components[this.change.type];
    },
  },
};
</script>

<style scoped lang="scss">

</style>
